/** @file Positional Object.is comparison of two dependency lists (memo keys). */

/** True when both lists have the same length and every position holds the same value (Object.is). */
export function sameDeps(a: readonly unknown[], b: readonly unknown[]): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (!Object.is(a[i], b[i])) return false;
  return true;
}
